import React from 'react';

import { ServiceStatsOverviewProps } from './ServiceStatsOverview.props';
import { StatsContainer, StatTile, StatNumber, StatLabel } from './ServiceStatsOverview.styles';

/**
 * ServiceStatsOverview - Displays clickable stat tiles for filtering services
 *
 * 3 tiles matching backend defaultReport categories:
 * - Allocated: Services allocated to current user (myServices)
 * - Depot: Services in user's depot (myDepot)
 * - Zones: Services in user's zones (myZones)
 */
export const ServiceStatsOverview: React.FC<ServiceStatsOverviewProps> = ({
  allocatedToMe,
  myDepot,
  myZones,
  onStatClick,
  activeFilter,
}) => {
  return (
    <StatsContainer>
      <StatTile
        active={activeFilter === 'allocated'}
        onClick={() => onStatClick('allocated')}
        data-testid="stat-tile-allocated"
      >
        <StatNumber>{allocatedToMe}</StatNumber>
        <StatLabel active={activeFilter === 'allocated'}>Allocated</StatLabel>
      </StatTile>

      <StatTile
        active={activeFilter === 'depot'}
        onClick={() => onStatClick('depot')}
        data-testid="stat-tile-depot"
      >
        <StatNumber>{myDepot}</StatNumber>
        <StatLabel active={activeFilter === 'depot'}>Depot</StatLabel>
      </StatTile>

      <StatTile
        active={activeFilter === 'zones'}
        onClick={() => onStatClick('zones')}
        data-testid="stat-tile-zones"
      >
        <StatNumber>{myZones}</StatNumber>
        <StatLabel active={activeFilter === 'zones'}>Zones</StatLabel>
      </StatTile>
    </StatsContainer>
  );
};
